import { AppRouter } from "./router/AppRouter"
import "./css/App.css"

function App() {


  return (
    <>
    <AppRouter/>
    </>
  )
}

export default App
